import { BasicFrame } from 'components/organisms';
import { frameConfigBasicTink } from '../../AppConfig';
import { LightbulbIcon } from 'components/icons';
import { ROUTES } from 'utils/constants/constants_routes';
import { useCustomNavigation } from 'hooks/useCustomNavigation';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from 'components/atoms/Card/Card';
import Link from 'components/atoms/Link/Link';
import styles from './TinkBankNA.module.scss';

export default function TinkBankNA() {
  const { t } = useTranslation('tinkBankNA');
  const navigate = useNavigate();
  const { navigateToOnlineBankVerification } = useCustomNavigation();

  const onDocCardHandler = () => {
    navigate(
      `${ROUTES.FIRST_LOAN_MANUAL_UPLOAD}?backRoute=${ROUTES.FIRST_LOAN_TINK_BANK_NA}`,
    );
  };

  const onLaterCardHandler = () => {
    navigate(ROUTES.FIRST_LOAN_TINK_LATER);
  };

  return (
    <BasicFrame
      {...frameConfigBasicTink}
      headerLayout="centered"
      onBackBtnHandler={navigateToOnlineBankVerification}
    >
      <div className={styles.layout} data-test="tinkBankNA-layout">
        <div className={styles.title} data-test="tinkBankNA-title">
          {t('title')}
        </div>
        <Card className={styles['doc-card']} data-test="tinkBankNA-docCard">
          <div
            className={styles.content}
            data-test="tinkBankNA-docCard-content"
          >
            {t('docCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankNA-button"
            onClick={onDocCardHandler}
          >
            {t('docCard.cto')}
          </button>
        </Card>
        <Card className={styles['later-card']} data-test="tinkBankNA-laterCard">
          <div
            className={styles.heading}
            data-test="tinkBankNA-laterCard-heading"
          >
            <LightbulbIcon data-test="tinkBankNA-laterCard-lightbulb" />
            <div
              className={styles.title}
              data-test="tinkBankNA-laterCard-title"
            >
              {t('laterCard.title')}
            </div>
          </div>
          <div
            className={styles.content}
            data-test="tinkBankNA-laterCard-content"
          >
            {t('laterCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankNA-laterCard-button"
            onClick={onLaterCardHandler}
          >
            {t('laterCard.cto')}
          </button>
        </Card>
        <div className={styles.footer} data-test="tinkBankNA-footer">
          {t('footer')}
        </div>
        <Link
          className={styles['footer-link']}
          data-test="tinkBankNA-footer-link"
          onClick={navigateToOnlineBankVerification}
        >
          {t('footerLink')}
        </Link>
      </div>
    </BasicFrame>
  );
}
